import React from "react";

export function Accordion({ items }) {
  return (
    <div className="e2-acc" data-testid="e2-accordion">
      {items.map((it, i) => (
        <details key={i} data-testid={`e2-acc-item-${i}`}>
          <summary>{it.q}</summary>
          {it.a.split("\n\n").map((p, j) => (
            <p key={j}>{p}</p>
          ))}
        </details>
      ))}
    </div>
  );
}
